//JS for homepage only goes here.
jQuery(document).ready(function ($) {
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === Node.TEXT_NODE) {
                        const emElement = mutation.target;
                        updateCompleteClass(emElement);
                    }
                });
            }
        });
    });
    
    const observerConfig = {childList: true};
    
    $("em.completion-percent").each(function () {
        $(this).data("previousPercentage", $(this).text());
        observer.observe(this, observerConfig);
        let percentageText = $(this).text();
        if (percentageText === "0%") {
            $(this).css("display", "none");
        } else {
            $(this).css("display", "");
        }
    });
});